__turbopack_context__.v({
  "megamenu-cms-item": "LBgHJq_megamenu-cms-item",
  "sub-category": "LBgHJq_sub-category",
  "submenu": "LBgHJq_submenu",
});
